// Author Liang Gang Qiang
// Date 2022-01-28 15:43:01

import * as model from "@/model/sithMes/inventory/SithMesInventoryOutdoorProcessModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryOutdoorProcess(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_INVENTORY_URL + '/sithMesInventoryOutdoorProcess/workflow/complete-feedback',
        processDefinitionKey: "sith_mes_inventory_outdoor",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
